<rl-reactive-file-input
    inactive-title="{{subtitle || 'Drag your ' + fileTypeCategoriesString + ' file here'}}"
    (filesChanged)="onFilesChanged($event)">
</rl-reactive-file-input>
